import DataManager from '../../common/data/DataManager'
import AppInfo from '../../common/constants/AppInfo'

/**
 * FrameViewクラス
 */
class FrameView extends PIXI.Graphics {
  // ---------------------------------------------------------------------------------------------------------
  // --	FrameView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();

    //zIndex（最前面）
    this.zIndex = 999
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	リサイズ
  // ---------------------------------------------------------------------------------------------------------

  resize()
  {
    //一旦クリア
    this.clear()

    //レンダラーサイズ取得
    const app = DataManager.getData('app')
    const screenW = app.renderer.width
    const screenH = app.renderer.height

    //横が大きい場合
    if(screenW > AppInfo.MAX_BG_WIDTH)
    {
      const rectW = (screenW - AppInfo.MAX_BG_WIDTH)/2

      this.beginFill(0x000000)
      this.drawRect(0, 0, rectW, screenH)
      this.drawRect(screenW - rectW, 0, rectW, screenH)
      this.endFill()
    }

    //縦が大きい場合
    if(screenH > AppInfo.MAX_BG_HEIGHT)
    {
      const rectH = (screenH - AppInfo.MAX_BG_HEIGHT)/2

      this.beginFill(0x000000)
      this.drawRect(0, 0, screenW, rectH)
      this.drawRect(0, screenH - rectH, screenW, rectH)
      this.endFill()
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default FrameView
